import { ActualContentBlockClientData, CalendarPlanBlockClientData } from '@yandex-int/k-common';
import { useGeneratePath, useStaticUrls } from 'platform-components';
import React from 'react';
import { useHistory, useParams } from 'react-router';

import { ShowcaseMetrikaParams } from 'common.components/typings';
import { ActualContentActivitiesList } from 'common.components/widgets.actual-content/__activities-list/actual-content__activities-list';
import {
    ActualContentWidgetItemData,
    getWidgetDataFromActualContentWidgetBlock,
} from 'common.components/widgets.actual-content/utils';
import { ContentShowcaseWidget } from 'common.components/widgets.content-showcase/content-showcase-widget';

interface Props {
    data: ActualContentBlockClientData;
    metrikaParams?: ShowcaseMetrikaParams;
    hideSelector?: boolean;
    grade?: number;
}

export const ActualContentWidgetView = (props: Props) => {
    const { data, metrikaParams, hideSelector } = props;
    const history = useHistory();
    const params = useParams<Record<string, string>>();
    const staticUrls = useStaticUrls();
    const generatePath = useGeneratePath();

    const widgetData = getWidgetDataFromActualContentWidgetBlock(data);

    const itemContent = ({ block, mix }: { block: CalendarPlanBlockClientData; mix?: string }) => {
        return <ActualContentActivitiesList block={block} metrikaParams={metrikaParams} mix={mix} />;
    };

    const handleTitleClick = (block: ActualContentWidgetItemData) => {
        const subject = block.slug;
        const path = params?.classId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary;

        history.push(generatePath(path, { subject }));
    };

    return (
        <ContentShowcaseWidget
            data={widgetData}
            hideSelector={hideSelector}
            itemContent={itemContent}
            key={data.id}
            onMainBlockTitleClick={handleTitleClick}
        />
    );
};
